module.exports = __webpack_public_path__ + "img/title@33x.434ff26f.png";